import { Component, Inject, OnInit } from '@angular/core';
import { ModalInput, ONEP_MODAL_INPUT } from '@onep/ng-uikit-lib/ui/modal';

@Component({
  selector: 'shared-info-forbidden-modal',
  templateUrl: './forbidden-modal.component.html',
  styleUrls: [],
})
export class ForbiddenModalComponent implements OnInit {
  constructor(@Inject(ONEP_MODAL_INPUT) private modalInput: ModalInput) {}

  ngOnInit(): void {}

  onRetryClick(): void {
    this.modalInput.close(null);
  }
}
